import { ReactElement } from "react";
import { App as AntApp, ConfigProvider, Spin } from "antd";
import { Provider } from "react-redux";
import { ApolloProvider } from "@apollo/client";
import dayjs from "dayjs";
import itIT from "antd/locale/it_IT";
import updateLocale from "dayjs/plugin/updateLocale";
import isBetween from "dayjs/plugin/isBetween";
import theme from "../../themeConfig";
import useAdapter from "./useAdapter";
import updatedLocale from "./updatedLocale";

dayjs.extend(isBetween);
dayjs.extend(updateLocale);
dayjs.updateLocale("it", updatedLocale);
dayjs.locale("it");

const Adapter = ({ children }: { children: ReactElement }) => {
  const {
    apolloClient, initialized, store
  } = useAdapter();

  if (!initialized) return (<Spin spinning fullscreen />);

  return (
    <ApolloProvider client={apolloClient}>
      <Provider store={store}>
        <AntApp>
          <ConfigProvider theme={theme} locale={itIT}>
            {children}
          </ConfigProvider>
        </AntApp>
      </Provider>
    </ApolloProvider>
  );
};

export default Adapter;
